<script setup lang="ts">
import { useVueNotoConsumer } from '@dialpad/noto/vue';
import { NotoDisplayScope } from '@dialpad/noto';
import NotoToast from '../NotoToast/NotoToast.vue';
import { DtStack } from '@dialpad/dialtone/vue3/lib/stack';
import { PowerdialerNotoType } from '@/noto';

const consumer = useVueNotoConsumer({
  scope: NotoDisplayScope.INLINE,
  types: new Set<PowerdialerNotoType>([
    PowerdialerNotoType.AutoDismiss,
    PowerdialerNotoType.SemiManualDismiss,
    PowerdialerNotoType.Error,
    PowerdialerNotoType.SyncError,
    PowerdialerNotoType.SyncSuccess,
  ]),
  fallbackComponent: NotoToast,
});
</script>
<template>
  <DtStack
    class="d-ps-fixed d-w100p d-ai-center d-t0 d-l0 d-mt32 d-zi-notification d-pe-none"
    gap="500"
  >
    <component
      :is="item.component"
      v-for="item in consumer.notos.value"
      :key="item.key"
      :noto="item.noto"
      @close="consumer.close(item.noto.id)"
    />
  </DtStack>
</template>
